import { render, staticRenderFns } from "./loadingApp.vue?vue&type=template&id=718463fb&scoped=true&"
import script from "./loadingApp.vue?vue&type=script&lang=js&"
export * from "./loadingApp.vue?vue&type=script&lang=js&"
import style0 from "./loadingApp.vue?vue&type=style&index=0&id=718463fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718463fb",
  null
  
)

export default component.exports